// SAMPLE catalog. Replace with VEYSO's real test list from its lab partner.
export const CATEGORIES = [
  {
    id: "heart-metabolic",
    name: "Heart & metabolic",
    count: 24,
    blurb: "How your body handles fats and sugar, and signals tied to long-term heart health.",
    markers: ["ApoB", "LDL cholesterol", "HDL cholesterol", "Triglycerides", "HbA1c", "Fasting insulin", "hs-CRP"],
  },
  {
    id: "hormones-thyroid",
    name: "Hormones & thyroid",
    count: 18,
    blurb: "Energy, mood, sleep and metabolism are all steered by hormones.",
    markers: ["TSH", "Free T4", "Free T3", "Testosterone", "Estradiol", "Cortisol", "SHBG"],
  },
  {
    id: "nutrients",
    name: "Nutrients & vitamins",
    count: 16,
    blurb: "Whether you are getting and absorbing what your body needs.",
    markers: ["Vitamin D", "Vitamin B12", "Folate", "Ferritin", "Magnesium", "Zinc"],
  },
  {
    id: "kidney-liver",
    name: "Kidney & liver",
    count: 14,
    blurb: "The organs that filter and process, checked for early changes.",
    markers: ["eGFR", "Creatinine", "ALT", "AST", "GGT", "Bilirubin"],
  },
  {
    id: "immune-inflammation",
    name: "Immune & inflammation",
    count: 12,
    blurb: "Signals of how your immune system is behaving.",
    markers: ["White blood cells", "ESR", "ANA screen", "Homocysteine"],
  },
  {
    id: "aging",
    name: "Aging & longevity",
    count: 10,
    blurb: "Markers that tend to shift as we age, so you can track the trend.",
    markers: ["Lp(a)", "IGF-1", "DHEA-S", "Uric acid"],
  },
];

export const ADD_ONS = [
  { id: "addon-vitd", name: "Vitamin D retest", price: 29, detail: "Single marker, results in days." },
  { id: "addon-gut", name: "Gut health panel", price: 149, detail: "Stool-based screen (sample)." },
  { id: "addon-allergy", name: "Allergy panel", price: 119, detail: "Common food and environmental allergens (sample)." },
  { id: "addon-mri", name: "Whole-body MRI", price: 999, detail: "Imaging partner appointment (sample)." },
];

// Sample results for the demo dashboard. Not real data.
export const SAMPLE_RESULTS = [
  { id: "ldl", name: "LDL cholesterol", unit: "mg/dL", value: 118, low: 0, high: 130, optimalHigh: 100, status: "watch", history: [132, 126, 121, 118], category: "Heart & metabolic" },
  { id: "apob", name: "ApoB", unit: "mg/dL", value: 92, low: 40, high: 120, optimalHigh: 90, status: "watch", history: [104, 99, 95, 92], category: "Heart & metabolic" },
  { id: "hba1c", name: "HbA1c", unit: "%", value: 5.2, low: 4, high: 5.7, optimalHigh: 5.4, status: "in", history: [5.5, 5.4, 5.3, 5.2], category: "Heart & metabolic" },
  { id: "tsh", name: "TSH", unit: "mIU/L", value: 2.1, low: 0.4, high: 4.5, optimalHigh: 2.5, status: "in", history: [2.6, 2.4, 2.2, 2.1], category: "Hormones & thyroid" },
  { id: "vitd", name: "Vitamin D", unit: "ng/mL", value: 24, low: 30, high: 100, optimalHigh: 80, status: "out", history: [18, 21, 22, 24], category: "Nutrients & vitamins" },
  { id: "b12", name: "Vitamin B12", unit: "pg/mL", value: 540, low: 200, high: 900, optimalHigh: 800, status: "in", history: [480, 500, 520, 540], category: "Nutrients & vitamins" },
  { id: "egfr", name: "eGFR", unit: "mL/min", value: 104, low: 90, high: 130, optimalHigh: 130, status: "in", history: [101, 102, 103, 104], category: "Kidney & liver" },
  { id: "hscrp", name: "hs-CRP", unit: "mg/L", value: 1.4, low: 0, high: 3, optimalHigh: 1, status: "watch", history: [2.2, 1.9, 1.6, 1.4], category: "Immune & inflammation" },
];

export const SAMPLE_PLAN = [
  { title: "Raise vitamin D", body: "Your level is below the reference range. Discuss a supplement with your clinician and retest in 12 weeks." },
  { title: "Keep trending LDL down", body: "LDL and ApoB are improving. Keep up the changes that are working and recheck at your follow-up visit." },
  { title: "Retest in 3 to 6 months", body: "Your follow-up panel is the best way to confirm these trends." },
];

// Used only when the API cannot be reached. Same shape the API returns (prices in cents).
export const FALLBACK_PRODUCTS = [
  { id: "membership", name: "VEYSO annual membership", detail: "Two visits a year, clinician-reviewed results, and a personal plan.", priceCents: 39900, type: "MEMBERSHIP" },
  ...ADD_ONS.map((a) => ({ id: a.id, name: a.name, detail: a.detail, priceCents: a.price * 100, type: "ADD_ON" })),
];

// Used only when the API cannot be reached: the sample results in the shape the API returns.
export const FALLBACK_DASHBOARD = {
  visitCount: 4,
  hasResults: true,
  counts: {
    in: SAMPLE_RESULTS.filter((r) => r.status === "in").length,
    watch: SAMPLE_RESULTS.filter((r) => r.status === "watch").length,
    out: SAMPLE_RESULTS.filter((r) => r.status === "out").length,
  },
  markers: SAMPLE_RESULTS,
  plan: SAMPLE_PLAN,
};
